export const SET_WRITERS = 'writers/SET_WRITERS';
export const UPDATE_WAITING = 'writers/UPDATE_WAITING';
export const UPDATE_CHAPTERS_WRITERS = 'writers/UPDATE_CHAPTERS_WRITERS';
export const CLEAR_CHAPTERS_WRITERS = 'writers/CLEAR_CHAPTERS_WRITERS';
export const SET_REFERENCES = 'writers/SET_REFERENCES';
export const SET_ASSIGNMENT = 'writers/SET_ASSIGNMENT';
